var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1779_52408)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D9D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0884 16.64C9.14843 16.64 7.86043 15.338 7.86043 13.434V13.21H9.45643V13.406C9.45643 14.638 9.96043 15.212 12.0324 15.212C13.9784 15.212 14.6784 14.764 14.6784 13.658C14.6784 12.706 14.0344 12.272 12.8584 12.272H10.2404V11.012H12.6484C13.7824 11.012 14.3704 10.592 14.3704 9.752C14.3704 8.842 13.8104 8.408 11.9904 8.408C10.0724 8.408 9.45643 8.982 9.45643 10.214V10.312H7.86043V10.186C7.86043 8.352 9.20443 6.98 12.1164 6.98C14.5104 6.98 15.8684 7.862 15.8684 9.458C15.8684 10.522 15.2384 11.278 14.0344 11.474V11.586C15.3924 11.824 16.2044 12.58 16.2044 13.882C16.2044 15.66 14.6504 16.64 12.0884 16.64Z",
    fill: "#523FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1779_52408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveThree);
export default __webpack_public_path__ + "static/media/inactive-three.e2daef394db88fae9e8a0236c2faca55.svg";
export { ForwardRef as ReactComponent };